import React, { useEffect, useContext } from "react";
import axios from "axios";
import { GlobalContext } from "../constants/Context";
import { logPlayCricketResponse } from "../utils/playCricketLogger";

const MatchDetailAPI = ({ matchId, onDataLoaded, onError, onLoading }) => {
  const { API_TOKEN } = useContext(GlobalContext);

  useEffect(() => {
    if (!matchId) return;

    const fetchMatchDetail = async () => {
      const url = `https://www.play-cricket.com/api/v2/match_detail.json?&match_id=${matchId}&api_token=${API_TOKEN}`;
      try {
        onLoading(true);
        const response = await axios.get(url);
        logPlayCricketResponse({
          endpoint: "match_detail",
          requestUrl: url,
          httpStatus: response.status,
          isSuccess: true,
          rawResponse: response.data,
        });
        const matchDetailData = response.data.match_details || {};
        onDataLoaded(matchDetailData);
        onLoading(false);
      } catch (err) {
        logPlayCricketResponse({
          endpoint: "match_detail",
          requestUrl: url,
          httpStatus: err.response?.status || null,
          isSuccess: false,
          rawResponse: err.response?.data || null,
          errorMessage: err.message,
        });
        onError(err.message);
        onLoading(false);
      }
    };

    fetchMatchDetail();
  }, [matchId]);

  return null;
};

export default MatchDetailAPI;